<template>
  <div class="intelligent">
    <div class="i_title">
      设备智能检测
    </div>
    <div class="i_show_module">
      <div class="i_diagnose" @click="diagnoseFun">
        <div class="diagnose_font HuXiaoBo">
          <!-- 一键诊断 -->
        </div>
      </div>
      <div class="i_status">
        <div class="status_box">
          <div class="status_font">
            <div class="status_line">
              <div>
                <span>监控设备：</span>
              </div>
              <div class="line_font">
                <span>{{ basiceInfo.dusterDeviceStatus }}</span>
              </div>
            </div>
            <div class="status_line">
              <div class="status_line">
                <span>治理设备：</span>
              </div>
              <div class="line_font">
                <span>{{ basiceInfo.monitorDeviceStatus }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="status_time">
          <div>
            上次诊断时间：
          </div>
          <div class="diagnose_time">
            <span>{{ basiceInfo.lastCheckTime }}</span>
          </div>
        </div>
      </div>
      <div class="i_posture">
        <div class="postureChart" ref="postureChart"></div>
        <div class="chart-desc">
          <div
            class="desc-item"
            v-for="(percent, index) in postureData"
            :key="`percent-${index}`"
          >
                <span
                  class="block"
                  :style="{ backgroundColor: getColor(index) }"
                ></span>
            <span>{{ percent.name + " " + percent.value + "%" }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="i_table_box">
      <div class="table_tab">
        <div class="i_tab">
          <div class="tab_item HuXiaoBo" :class="{ isChoose: isChoose == 'monitor' }" @click.prevent="changTab('monitor')">
            <span>监控设备</span>
          </div>
          <div class="tab_item HuXiaoBo" :class="{ isChoose: isChoose == 'governance' }" @click.prevent="changTab('governance')">
            <span>治理设备</span>
          </div>
        </div>
        <div class="show_detail HuXiaoBo" @click="downloadFile">
          查看详情 》
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        height="100%"
      >
        <el-table-column
          prop="branchFactoryName"
          label="分厂/所属区域"
          align="center"
          width="210"
        >
      </el-table-column>
        <el-table-column
          prop="productLineName"
          label="生产工艺线"
          align="center"
          width="210"
        >
        </el-table-column>
        <el-table-column
          prop="total"
          label="数量"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="handleRate"
          label="处理率"
          align="center"
          width="150"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="etc"
          label="预计完成时间"
          align="center"
          width="170"
        >
        </el-table-column> -->
      </el-table>
    </div>
    <div class="diagnose_dialog" v-if="showDiagnose">
      <img src="./img/image.png" alt="">
      <div class="font">将开始诊断···</div>
      <div class="diagnose_but">
        <div class="but" @click="startDiagnose" >确定</div>
        <div class="but" @click="closeDiagnose">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPieSeries } from '../factoryData';
import jsonData from  '/public/static/js/json/operatieCenter.json';
export default {
  name: 'intelligentMonitoring',
  title: '设备智能监测',
  data() {
    return {
      nowDate: '',
      monitoringEquipment: '',
      governanceEquipment: '',
      lastDiagnosisTime: '',
      isChoose: 'monitor',
      chooseName: 'monitor',
      tableData: [

      ],
      monitorData: [

      ],
      governanceData: [

      ],
      postureData: [
      ],
      showDiagnose: false,
      basiceInfo: {}
    }
  },
  created() {
    this.checkProblemInfo()
    this.checkTaskInfo(3)
  },
  mounted() {
    // this.lastDiagnosisTime = jsonData.intelligentMonitor.lastDiagnosisTime;
    // this.monitorData = jsonData.intelligentMonitor.monitorData.slice(0,4);
    // this.governanceData = jsonData.intelligentMonitor.governanceData.slice(0,4);
    // this.tableData = this.monitorData;
    // this.nowDate = jsonData.intelligentMonitor.nowDate;
    // this.monitoringEquipment = jsonData.intelligentMonitor.monitoringEquipment;
    // this.governanceEquipment = jsonData.intelligentMonitor.governanceEquipment;
    
  },
  methods: {
    // 上一次检测结果
    async checkProblemInfo () {
      let that = this
      let url =
          CONFIG.requestName + this.$apiOpt.checkProblemInfo;
      this.$apiUtils
        .get(url, {
            customerId: this.$store.state.customerId,
        })
        .then(function (data) {
          console.log('data111', data)
          that.basiceInfo = data
          that.postureData = [
            {
              name: '正常',
              value: data.normalDeviceRate
            },{
              name: '异常',
              value: data.problemDeviceRate
            }
          ]

          that.getPostureData();
        });
    },

    downloadFile () {
      // let name;
      // if (this.chooseName === 'monitor') {
      //     name = '监控设备';
      // } else {
      //   name = '治理设备';
      // }
      // const a = document.createElement('a');
      // a.setAttribute('href', 'download/');
      // a.setAttribute('download', `${name}.xlsx`);
      // a.click();
      console.log("123")
      this.$store.commit("upDateOperationCenterDialog", {state: true, params: {type: '诊断详情', value: this.basiceInfo.lastCheckTime}});
    },
    diagnoseFun() {
      this.showDiagnose = true
    },
    // 一键诊断
    async startDiagnose() {
      // this.$message.success('开始诊断中，请稍等')
      setTimeout(() => {
        this.showDiagnose = false
      }, 1000)
      let url = CONFIG.requestName + this.$apiOpt.checkTask + '?customerId=' + this.$store.state.customerId
      try {
      this.$apiUtils
        .post(url, {})
        .then( data => {
          this.$message.success('正在诊断中...')
          this.checkProblemInfo()
          this.checkTaskInfo(3)
          this.changTab(this.chooseName)
        });
       } catch(err) {
        this.$message.success('诊断出错！请稍后再试')
      }
    },
    // 诊断任务统计信息
    async checkTaskInfo(id) {
      let that = this
      let url =
          CONFIG.requestName + this.$apiOpt.checkTaskInfo;
      this.$apiUtils
        .get(url, {
            customerId: this.$store.state.customerId,
            primaryTypeId: id
        })
        .then(function (data) {
          console.log('data1', data)
          for (let item of data) {
            item.handleRate += "%"
          }
          that.tableData = data
        });
    },
    closeDiagnose() {
      this.showDiagnose = false
    },
    getColor(i) {
      let colorList = ['#3BDEFF', '#5c5886', '#f9bf53'];
      return colorList[i % 3];
    },
    /**
     * @Description: 获取设备态势数据
     * @author liqiuyu
     * @date 2023/2/10
     * @return void
    */
    getPostureData() {
      this.$nextTick(()=>{
        if (!this.postureChart) {
          this.postureChart = echarts.init(this.$refs.postureChart);
        }
        console.log('this.postureChart',this.postureChart);
        this.postureChart.setOption(getPieSeries(this.postureData));
      });
    },
    changTab(type) {
      this.isChoose = type;
      this.chooseName = type;
      if(type === 'monitor') {
        // this.tableData = this.monitorData;
        this.checkTaskInfo(3)
      } else {
        // this.tableData = this.governanceData;
        this.checkTaskInfo(2)
      }
    }
  },
  beforeUnmount() {
    if (this.postureChart) {
      this.postureChart.dispose();
      this.postureChart = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.intelligent {
  transition: none 0s ease 0s;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .diagnose_dialog {
    position: absolute;
    left: 151px;
    top: 91px;
    width: 478px;
    height: 316px;
    background: rgba(3,15,39,0.8);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(227deg, rgba(46.26106224954128, 241.08411312103271, 255, 1), rgba(30.28326541185379, 52.60314233601093, 253.48214864730835, 1)) 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .font {
      font-size: 32px;
      margin-top: -5px;
    }
    .diagnose_but {
      display: flex;
      align-items: center;
      margin-top: 35px;
      .but {
        width: 96px;
        height: 40px;
        background: linear-gradient(195deg, #00C6FF 0%, #0072FF 100%);
        // border-radius: 4px 4px 4px 4px;
        margin-right: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 24px;
        &:last-child {
          background: rgba(0,0,0,0.2);
          // border-radius: 4px 4px 4px 4px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(0, 113.00000086426735, 255, 1), rgba(0, 197.0000034570694, 255, 1)) 1 1;
          margin-right: 0px;
        }
      }
    }
    img {
      width: 176px;
      height: 176px;
    }
  }
  .i_title {
    font-size: 30px;
    color: #63F2EF;
    padding-left: 20px;
    font-weight: 600;
  }
  .i_show_module {
    display: flex;
    font-size: 20px;
    height: 165px;
    padding-top: 5px;
    box-sizing: border-box;
    .i_diagnose {
      @include bg-box(28%, 140px, 'diagnose.png');
      background-size: contain;
      display: flex;
      justify-content: center;
      align-items: center;
      .diagnose_font {
        width: 40px;
        color: #FDFDFD;
      }
    }

    .i_status {
      width: 40%;
      margin-left: -2%;
      position: relative;
      .status_box {
        @include bg-box(100%, 120px, 'frame.png');
        background-size:inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        .status_font {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px;
          margin-bottom: 10px;

          .status_line {
            display: flex;
            .line_font {
              color:#50a8e7;
            }
          }
        }
      }

      .status_time {
        display: flex;
        justify-content: center;
        margin-top: 5px;
        position: absolute;
        width: 400px;
        left: 50%;
        bottom: 5px;
        transform: translateX(-50%);
      }
    }

    .i_posture {
      position: relative;
      width: 32%;
      .postureChart {
        height: 140px;
        width: 140px;
      }
      .chart-desc {
        position: absolute;
        right: -5px;
        top: 68px;
        transform: translateY(-50%);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 83px;
        box-sizing: border-box;
        .desc-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 30px;
          font-size: 13px;
          color: white;
          .block {
            margin-right: 5px;
            width: 14px;
            height: 10px;
          }
        }
        .desc-item:last-child {
          width: 100%;
        }
      }
    }
  }
  .i_table_box {
    padding: 10px 10px 0;
    background: transparent;
    overflow-y: auto;
    flex: 1;
    // height: 100%;
    display: flex;
    flex-direction: column;
    .table_tab {
      display: flex;
      margin-bottom: 5px;
      font-size: 22px;
      background: #141c5b;
      align-items: center;
      .i_tab {
        display: flex;
        width: 70%;
        border-radius: 30px;
        border: 1px solid;

        .tab_item {
          display: flex;
          flex: 1;
          justify-content: center;
          border-radius: 30px;
          cursor: pointer;
          line-height: 30px;
        }
        .isChoose {
          @include bg-box(100%, 30px, 'tabItem.png');
          background-size:inherit;
        }
      }
      .show_detail {
        margin-left: auto;
        color: #64c6ef;
        cursor: pointer;
      }
    }
    .el-table {
          background: transparent;
          flex: 1;
          height: 100%;
        }
        :deep(.el-table) {
            th > .cell {
                color: #49d9d2 !important;
                font-size: 20px;
            }
            

            tbody {
                .cell {
                    color: #c6d6df;
                }
                .el-table__row {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%
                    );
                    // border: 1px solid #8BADFF;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }

                .el-table__row--striped {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    ) !important;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }
            }
        }
        :deep(.el-table__header) {
            width: auto !important;
            .has-gutter {
                height: 50px;
                background: transparent;
                // filter: blur(38.08000183105469px);
                border: 1px solid #84aaff;
                tr th {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    );
                    border-bottom: 1px solid #8badff;
                }
            }
        }
        :deep(.el-table th > .cell) {
            white-space: initial;
            overflow: initial;
            font-size: 24px;
            color: #47ffdd !important;
        }
        :deep(.el-table__body) {
            width: auto !important;
        }
        :deep(.el-table__body-wrapper) {
            overflow-x: hidden;
            .el-table__empty-block {
                width: auto !important;
            }
        }
  }
  .i_time {
    display: flex;
    width: 130px;
    float: right;
  }
}
.intelligent :deep(.el-pagination) {
  span:not([class*="suffix"]),
  .el-pagination button {
    line-height: 20px;
  }
}

.intelligent :deep(.el-pagination__editor) {
  .el-input__inner {
    height: 20px !important;
    font-size: 16px !important;
  }
}

.intelligent :deep(.el-table) {
  &::before {
    height: 0px !important;
  }
}
</style>

